export const TestEventsListType = Object.freeze({
    REQUESTS: 'requests',
    EVENTS: 'events',
})